class Slider {
    constructor() {
        this.slider = document.querySelector(".slider");

        if (this.slider) {
            this.ol = this.slider.querySelector("ol");
            this.offset = 0;
            this.maxOffset = (this.ol.querySelectorAll("li").length - 2) * 260;
            this.slide = this.slide.bind(this);
            this.bindSlider();
        }
    }

    slide(action) {
        if (action === "previous" && this.offset > 0) {
            this.offset -= 260;
        } else if (action === "next" && this.offset < this.maxOffset) {
            this.offset += 260;
        }
        this.ol.style.transform = `translateX(-${this.offset}px)`;
    }

    bindSlider() {
        this.slider.querySelector("#slider-previous").addEventListener("click", () => this.slide("previous"));
        this.slider.querySelector("#slider-next").addEventListener("click", () => this.slide("next"));
    }
}

export default Slider;
